import { render, staticRenderFns } from "./TaskDurationView.vue?vue&type=template&id=3d09cc45"
import script from "./TaskDurationView.vue?vue&type=script&lang=js"
export * from "./TaskDurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports